import { defineComponent, toRefs, computed, withModifiers, ref } from 'vue';
// import { withInstall } from '../_util/type';
import { 
// Direction,
OperationType, TreeNodeType, 
// TRADIND_KEYS,
// ToolsStatusEnum,
// CONDITION_HEAD_NODE_HEIGHT,
ICON_SIZE, } from './utils/types';
// import { getOffset } from './utils';
import useConfigInject from '../_util/hooks/useConfigInject';
import { findChildrenNodeList, hasErrorToolInLink, isNodeInMerge } from './utils/tool';
import Icon from '../icon';
// import Tools from './Tools';
import Dropdown from '../dropdown';
import Menu, { MenuItem } from '../menu';
import classNames from '../_util/classNames';
export const nodeProps = () => ({
    graph: Object,
    node: Object,
    index: Number,
    isMove: Boolean,
    isTemEdge: Boolean,
    nodeIntercept: Function,
    lineDrop: Boolean,
    nodeDrop: Boolean,
    className: String,
    nodeList: {
        type: Array,
        default: () => [],
    },
    linkList: {
        type: Array,
        default: () => [],
    },
    modelPathList: {
        type: Array,
        default: () => [],
    },
    merge: Boolean,
    selectedNodeId: Array,
    disabledLine: {
        type: Boolean,
        default: true,
    },
    nodeMousedown: Function,
    nodeMouseenter: Function,
    nodeMouseleave: Function,
    nodeMouseup: Function,
    // sideMousedown: Function,
    nodeSelect: Function,
    nodeDelete: Function,
    nodeShrink: Function,
    menuClick: Function,
    menus: Array,
    readonly: Boolean,
    getMenuPopupContainer: { type: Function },
    scrollRef: { type: Object },
    onDrag: Function,
    onDragEnd: Function,
    dragging: Boolean,
    nodeClick: Function,
});
const StgyFlowNode = defineComponent({
    compatConfig: { MODE: 3 },
    name: 'WdStgyFlowNode',
    props: nodeProps(),
    emits: [
        'node-mousedown',
        'node-select',
        'node-mouseenter',
        'node-mouseleave',
        'node-mouseup',
        'node-contextmenu',
        'side-mousedown',
        'node-insert',
    ],
    slots: ['header', 'content', 'tools'],
    setup(props, { slots }) {
        const { prefixCls } = useConfigInject('stgy-flow-node', props);
        const { node, linkList, merge, 
        // nodeDrop,
        selectedNodeId, className, modelPathList, nodeList, menus, readonly, getMenuPopupContainer, dragging, } = toRefs(props);
        // const state = reactive({
        //   direction: Direction,
        //   output: props.nodeIntercept,
        // });
        const nodeRef = ref();
        const style = computed(() => {
            const { position, width, height } = node.value;
            return {
                width: width + 'px',
                height: height + 'px',
                top: position[1] + 'px',
                left: position[0] + 'px',
            };
        });
        const notToolsNode = computed(() => {
            return node.value?.meta?.type !== TreeNodeType.TOOLS;
        });
        const insertNodeStyle = computed(() => {
            const { width, meta } = node.value;
            return {
                position: 'absolute',
                top: (meta?.extParam?.isMergeNode ? -(ICON_SIZE / 2) : 6) + 'px',
                left: (hasNextNodeAndNotEmpty.value ? width + 60 : width + 40) + 'px',
            };
        });
        const isOpen = computed(() => node.value.meta.extParam.isOpen);
        const shrinkNodeStyle = computed(() => {
            const { width, meta } = node.value;
            return {
                position: 'absolute',
                top: (meta?.extParam?.isMergeNode ? -(ICON_SIZE / 2) : 6) + 'px',
                left: width + (isOpen.value ? 24 : 40) + 'px',
            };
        });
        const deleteNodeStyle = computed(() => {
            const { width } = node.value;
            return {
                position: 'absolute',
                top: `${notToolsNode.value ? 8 : 7}px`,
                left: width - 18 - 12 + 'px',
            };
        });
        const isLastNode = computed(() => {
            const startIds = linkList.value.map((link) => link?.startId);
            // 被合并的节点也要判断后面是否是空节点
            const mergeLink = linkList.value.find(link => {
                return node.value.id === link.startId && link.meta?.activeId !== -1;
            });
            // 判断空节点是否为最后节点 要用来判断这个空节点后面有没有连接其它阶段 没有的话则是最后节点
            if (mergeLink) {
                return !linkList.value.some(link => mergeLink?.endId === link.startId);
            }
            return !startIds.includes(node.value.id);
        });
        // 是否有下一个节点
        const hasNextNode = computed(() => linkList.value.some(link => link.startId === node.value.id));
        // 是否有下一个节点,并且下一个节点不是空节点
        const hasNextNodeAndNotEmpty = computed(() => {
            return linkList.value.some(link => link.startId === node.value.id && link.meta?.activeId === -1 && !link.meta?.isDragElement);
        });
        const nodeClassNames = computed(() => {
            const classNameObj = {
                [`${prefixCls.value}`]: true,
                'last-node': isLastNode.value,
                'merge-node': merge.value,
                'selected-node': selectedNodeId.value.includes(node.value.id),
                'lighten-node': node.value?.meta?.isHighLight,
                'start-node': node.value?.meta?.configKey === 'start_node',
                'dragging-node': dragging.value,
            };
            const key = className.value;
            key && (classNameObj[key] = true);
            return classNameObj;
        });
        const isInMerge = computed(() => {
            return isNodeInMerge({
                nodeId: node.value.id,
                modelPathList: modelPathList.value,
                nodeList: nodeList.value,
            });
        });
        const isInErrorToolLink = computed(() => {
            return hasErrorToolInLink({
                nodeId: node.value.id,
                modelPathList: modelPathList.value,
                nodeList: nodeList.value,
            });
        });
        const isInMergeLastNode = computed(() => {
            const link = linkList.value.find(item => item.startId === node.value.id);
            return isInMerge.value && link?.meta?.activeId !== -1;
        });
        // 展开收起禁用
        const shrinkDisabled = computed(() => merge.value || isInMerge.value || isInErrorToolLink.value);
        const nodeMousedown = (evt) => {
            props.nodeMousedown(evt, node.value);
        };
        const nodeMouseup = () => {
            props.nodeMouseup();
            if (merge.value) {
                props.nodeSelect({
                    nodeId: node.value.id,
                    isLastNode: isLastNode.value,
                });
            }
        };
        const nodeDelete = () => {
            props.nodeDelete(node.value);
        };
        const nodeShrink = () => {
            if (shrinkDisabled.value) {
                return;
            }
            props.nodeShrink(node.value);
        };
        // 获取收起数量
        const getShrinkNodeAfterNum = () => {
            return (findChildrenNodeList({
                nodeId: node.value.id,
                modelPathList: modelPathList.value,
                nodeList: nodeList.value,
            })?.filter(item => !item.meta.extParam.isMergeNode && !item.meta?.extParam?.isDragElement)
                ?.length - (node.value.meta.extParam.isMergeNode ? 0 : 1));
        };
        const handleMenuClick = (key) => {
            props.menuClick({ type: OperationType.INSERT, key, node: node.value });
        };
        const nodeDeleteDown = () => {
            // 占位
        };
        return () => {
            let deleteNode = null;
            if (node.value?.meta?.type !== TreeNodeType.TOOLS &&
                node.value.meta?.configKey !== 'start_node' &&
                !readonly.value) {
                deleteNode = (<>
            <div onMousedown={withModifiers(nodeDeleteDown, ['left', 'prevent', 'stop'])} onMouseup={withModifiers(nodeDelete, ['left', 'prevent', 'stop'])} style={deleteNodeStyle.value} class="node-delete">
              <Icon class={`icon-delete ${notToolsNode.value ? '' : 'icon-tools-delete'}`} icon-class="wd-icon-tips_close_circle"></Icon>
            </div>
          </>);
            }
            let insertNode = null;
            if (!isInMergeLastNode.value &&
                !readonly.value &&
                !node.value.meta?.extParam.hiddenInsert &&
                node.value.meta?.extParam.isOpen) {
                insertNode = (<>
            <Dropdown trigger={'click'} getPopupContainer={getMenuPopupContainer.value} disabled={node.value.meta?.extParam?.menuDisabled || merge.value} destroyPopupOnHide v-slots={{
                        overlay: () => (<Menu onClick={({ key }) => {
                                handleMenuClick(key);
                            }}>
                    {menus.value.map(menu => {
                                return <MenuItem key={menu.value}>{menu.name}</MenuItem>;
                            })}
                  </Menu>),
                        default: () => (<div style={insertNodeStyle.value} class="node-insert">
                    <Icon class="icon-plus" icon-class="wd-icon-tips_plus_circle"></Icon>
                    {hasNextNode.value ? null : (<div class={classNames('node-insert-line', {
                                    ['node-insert-line__merge']: node.value.meta?.extParam?.isMergeNode,
                                })}></div>)}
                  </div>),
                    }}></Dropdown>
          </>);
            }
            let shrinkNode = null;
            if (hasNextNodeAndNotEmpty.value) {
                shrinkNode = (<>
            <div style={shrinkNodeStyle.value} class={classNames('node-shrink', {
                        [`node-shrink-disabled`]: shrinkDisabled.value,
                        [`node-shrink-collaspe`]: !isOpen.value,
                        [`node-shrink-merge-collaspe`]: node.value.meta?.extParam?.isMergeNode && isOpen.value === false,
                    })}>
              {isOpen.value ? (<Icon icon-class="wd-icon-tips_minus_circle" class="node-shrink-icon" onMousedown={withModifiers(nodeShrink, ['left', 'prevent', 'stop'])}></Icon>) : (<div class="node-shrink-expand">
                  {getShrinkNodeAfterNum() > 99 ? (<Icon icon-class="wd-icon-interactive_more" class="node-shrink-icon" onMousedown={withModifiers(nodeShrink, ['left', 'prevent', 'stop'])}></Icon>) : (<span class="node-shrink-text" onMousedown={withModifiers(nodeShrink, ['left', 'prevent', 'stop'])}>
                      {getShrinkNodeAfterNum()}
                    </span>)}
                  <div class="node-shrink-line"></div>
                </div>)}
            </div>
          </>);
            }
            let renderNode = null;
            if (node.value?.meta?.type === TreeNodeType.TOOLS) {
                const renderToolsNode = slots?.tools;
                if (renderToolsNode) {
                    renderNode = (<>
              <div onMousedown={nodeMousedown} onMouseup={nodeMouseup}>
                {renderToolsNode()}
              </div>
            </>);
                }
            }
            else {
                renderNode = (<>
            {node.value.width > 0 && (<div class={classNames({
                            [`${prefixCls.value}-wrap`]: true,
                            [`${prefixCls.value}-wrap-buy`]: node.value?.meta?.configKey === 'buy',
                            [`${prefixCls.value}-wrap-sell`]: node.value?.meta?.configKey === 'sell',
                        })} onMousedown={nodeMousedown} onMouseup={nodeMouseup}>
                <div class={`${prefixCls.value}-wrap-header`}>{slots?.header?.()}</div>
                <div class={`${prefixCls.value}-wrap-bottom`}>{slots?.content?.()}</div>
                {deleteNode}
              </div>)}
          </>);
            }
            if (node.value?.meta?.extParam?.isDragElement) {
                const dragStyle = {
                    width: node.value.width + 'px',
                    height: node.value.height + 'px',
                    left: node.value.position[0] + 'px',
                    top: node.value.position[1] + 'px',
                };
                return (<>
            <div data-id={node.value.id} style={dragStyle} class={`${prefixCls.value}-dragging`}></div>
          </>);
            }
            else {
                return (<div ref={nodeRef} tabindex="-1" class={nodeClassNames.value} style={style.value} data-id={node.value.id}>
            {renderNode}
            {/* {slots.default?.()} */}
            {shrinkNode}
            {insertNode}
          </div>);
            }
        };
    },
});
export default StgyFlowNode;
